<template>
  <BasicTemplate>
    <h3>
      <router-link to="/games">Games</router-link> /
      <router-link :to="`/games/${$route.params.gameId}`">Game #{{ $route.params.gameId }} ({{ parent.name }})</router-link> /
      New Game Meta: {{ item.locale }}
    </h3>
    <Form :parent="parent" :item="item" @change="save" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../../templates/basic.vue';
import Form from './form.vue';

export default {
  name: 'MetaEdit',
  components: { BasicTemplate, Form },
  data() {
    return {
      categories: [],
      parent: { id: this.$route.params.gameId },
      item: { gameId: this.$route.params.gameId, locale: 'en', categories: [] },
    };
  },
  async created() {
    this.$watch(() => this.$route.params, (newParams, prevParams) => this.load());
    await this.load();
  },
  methods: {
    async load() {
      const { gameId } = this.$route.params;
      this.parent = await this.$gameApi.get(`/games/${gameId}`);
    },
    async save() {
      try {
        const { gameId } = this.$route.params;
        const item = await this.$gameApi.post(`/games/${gameId}/metas/`, this.item);
        this.$swal.fire({ icon: 'success', title: 'Game meta saved.', timer: 1500, showConfirmButton: false });
        this.$router.push(`/games/${gameId}/metas/${item.id}`);
      } catch (e) {
        this.$swal.fire({ icon: 'error', title: e.message, timer: 1500, showConfirmButton: false });
      }
    }
  }
};
</script>
